import Layout from "../../../components/Layout";
import FormPutFunc from "../Formularios/formPutFunc";

export default function PutFunc() {
  return Layout(FormPutFunc, "Funcionarios");
}
